import {Button, Card, Col, Container, Form, Input, Row, Spinner} from "reactstrap";
import DataTable from "react-data-table-component";
import {useEffect, useState} from "react";
import {Link, useHistory, useParams} from "react-router-dom";
import {collection, doc, getDoc, getDocs, query, updateDoc, where} from "firebase/firestore";
import {getDb} from "../../util/Constants";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";

export default function Levels(props) {
    const [sheetData, setSheetData] = useState([]);
    const [miscellaneousData, setMiscellaneousData] = useState([]);
    const [loadingLevelData, setLoadingLevelData] = useState(true);
    const [editing, setEditing] = useState(null);
    const [lAbilities, setLAbilities] = useState([]);
    const [loading, setLoading] = useState(null);

    const history = useHistory();
    const {eventId} = useParams();
    const db = getDb();


    useEffect(async () => {
        let dataArr = []
        const q = query(collection(db, "Levels"), where("eventId", "==", eventId));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            let data = doc.data();
            data.id = doc.id; // Add document ID to each level
            // console.log("doc.id", doc.id)
            data = {...data, id: doc.id}; // Add the document ID to the data object
            dataArr.push(data)

        });

        // Sort by sortingOrder, but ensure demo levels (final === 'd') are always at the end
        const arr = dataArr.sort(function (a, b) {
            // If one is demo and the other is not, demo goes last
            if (a.final === 'd' && b.final !== 'd') return 1;
            if (a.final !== 'd' && b.final === 'd') return -1;
            // Otherwise sort by sortingOrder
            return a.sortingOrder - b.sortingOrder;
        });
        setSheetData(arr)
        await miscellaneous()
        await abilities()

    }, []);
    useEffect(() => {
        console.log("sheetData", sheetData);
    }, [sheetData])

    const miscellaneous = async () => {
        let obj = {}
        const docRef = doc(db, "miscellaneous", eventId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            obj = docSnap.data().data;
            const data = Object.keys(obj).map((e) => {
                return {
                    name: e,
                    value: obj[e]
                }
            })
            setMiscellaneousData(data)
            console.log(data);
        } else {
            // docSnap.data() will be undefined in this case
        }
    }
    const abilities = async () => {
        const docRef = doc(db, "Events", eventId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data().selectedLevels.competencies.map((e) => {
                return {name: e.name, text: e.description}
            })
            setLAbilities(data)
        }

        setLoadingLevelData(false);
    }
    const onDragEnd = async (result) => {
        if (!result.destination) return;

        // Find the demo level index
        const demoIndex = sheetData.findIndex(item => item.final === 'd');
        const lastIndex = sheetData.length - 1;

        // Prevent demo level from being moved
        if (result.source.index === demoIndex && demoIndex !== -1) {
            return;
        }

        // Prevent dragging below demo level
        if (demoIndex !== -1 && result.destination.index > demoIndex) {
            return;
        }

        // Reorder the data array
        let updatedData = Array.from(sheetData);
        const [movedItem] = updatedData.splice(result.source.index, 1);
        updatedData.splice(result.destination.index, 0, movedItem);

        // Ensure demo level stays at the end
        if (demoIndex !== -1) {
            const demoItem = updatedData.find(item => item.final === 'd');
            if (demoItem) {
                const currentDemoIndex = updatedData.findIndex(item => item.final === 'd');
                if (currentDemoIndex !== updatedData.length - 1) {
                    updatedData.splice(currentDemoIndex, 1);
                    updatedData.push(demoItem);
                }
            }
        }

        // Update sortingOrder only, preserve existing final values
        updatedData = updatedData.map((item, index) => ({
            ...item,
            sortingOrder: index + 1
        }));

        setSheetData(updatedData);
        // console.log("updatedData", updatedData)
        // Update Firebase
        try {
            for (const item of updatedData) {
                console.log("Entered in loop", item);
                if (item.id) { // Ensure the item has an ID for updating
                    const levelRef = doc(db, "Levels", item.id);

                    // Create a plain object by excluding "id"
                    const {id, ...dataToUpdate} = item;

                    // Log the object to check its structure
                    console.log("Updating Firebase with:", dataToUpdate);

                    // Ensure dataToUpdate is a plain object
                    await updateDoc(levelRef, dataToUpdate);
                }
            }
        } catch (error) {
            console.error("Error updating Firebase:", error);
        }
    };
    const renderQuestionsColumn = (row) => {
        let _values = [];
        const isLevel = Number.isInteger(Number(row["tabName"]));
        if (isLevel) {
            _values = row["totalQuestion"].split("|");
        }

        return (
            <div>
                {isLevel ? (
                    <div className="py-1">
                        <div>
                            {_values[0]} <span className="small text-muted ml-1">Questions</span>
                        </div>
                        <div>
                            {_values[1]} <span className="small text-muted ml-2">Emails</span>
                        </div>
                        <div>
                            {_values[2]} <span className="small text-muted ml-2">SMS</span>
                        </div>
                    </div>
                ) : (
                    <div>{row["totalQuestion"]}</div>
                )}
            </div>
        );
    };
    const handleMakeFinal = async (index) => {
        let updatedData = [...sheetData];

        // Find the row that currently has final === 'y'
        const prevFinalIndex = updatedData.findIndex(row => row.final === 'y');

        // Reset the previous 'y' row to 'n' (if exists)
        if (prevFinalIndex !== -1) {
            updatedData[prevFinalIndex] = {...updatedData[prevFinalIndex], final: 'n'};
        }

        // If the clicked row is currently a demo, reset it
        if (updatedData[index].final === 'd') {
            // Find and remove the demo level from the end if it exists
            const demoIndex = updatedData.findIndex(row => row.final === 'd');
            if (demoIndex !== -1) {
                updatedData[demoIndex] = {...updatedData[demoIndex], final: 'n'};
            }
        }

        // Set the clicked row's final property to 'y'
        updatedData[index] = {...updatedData[index], final: 'y'};

        // Reassign sortingOrder for all rows (keeping same positions)
        updatedData = updatedData.map((item, i) => ({
            ...item,
            sortingOrder: i + 1
        }));

        // Update the state
        setSheetData(updatedData);

        console.log("updatedData", updatedData);

        // Update Firebase with the new ordering
        try {
            for (const item of updatedData) {
                if (item.id) {
                    const levelRef = doc(db, "Levels", item.id);
                    const {id, ...dataToUpdate} = item;
                    await updateDoc(levelRef, dataToUpdate);
                }
            }
        } catch (error) {
            console.error("Error updating Firebase:", error);
        }
    };

    const handleMakeDemo = async (index) => {
        let updatedData = [...sheetData];

        // Find the row that currently has final === 'd' (demo)
        const prevDemoIndex = updatedData.findIndex(row => row.final === 'd');

        // Reset the previous 'd' row to 'n' (if exists)
        if (prevDemoIndex !== -1) {
            updatedData[prevDemoIndex] = {...updatedData[prevDemoIndex], final: 'n'};
        }

        // If the clicked row is currently final ('y'), reset it
        if (updatedData[index].final === 'y') {
            updatedData[index] = {...updatedData[index], final: 'n'};
        }

        // Set the clicked row's final property to 'd'
        updatedData[index] = {...updatedData[index], final: 'd'};

        // Move the demo level to the last position
        const demoRow = updatedData.splice(index, 1)[0];
        updatedData.push(demoRow);

        // Reassign sortingOrder for all rows
        updatedData = updatedData.map((item, i) => ({
            ...item,
            sortingOrder: i + 1
        }));

        // Update the state
        setSheetData(updatedData);

        console.log("updatedData", updatedData);

        // Update Firebase with the new ordering
        try {
            for (const item of updatedData) {
                if (item.id) {
                    const levelRef = doc(db, "Levels", item.id);
                    const {id, ...dataToUpdate} = item;
                    await updateDoc(levelRef, dataToUpdate);
                }
            }
        } catch (error) {
            console.error("Error updating Firebase:", error);
        }
    };

    return (
        <>
            <Container fluid>
                <Row className="mb-4">
                    <Col>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="table">
                                {(provided) => (
                                    <table
                                        className="custom-rounded-table w-full custom-border-radius border border-gray-200"
                                        ref={provided.innerRef} {...provided.droppableProps}>
                                        <thead>
                                        <tr className="table-custom-header">
                                            <th className="p-4 wd-normal-row">Game Name</th>
                                            <th className="p-4 wd-normal-row">Evaluation</th>
                                            <th className="p-4 wd-normal-row">Level Name</th>
                                            <th className="p-4 wd-normal-row">Passing Score</th>
                                            <th className="p-4 wd-normal-row">Time (sec)</th>
                                            <th className="p-4 wd-normal-row">Questions</th>
                                            {/*<th className="p-4 wd-normal-row">Min. Attempts</th>*/}
                                            <th className="p-4 wd-normal-row">Type</th>
                                            {/*<th className="p-4 wd-normal-row">Difficulty</th>*/}
                                            <th className="p-4 wd-wide-row">Level Objective</th>
                                            <th className='p-4 wd-normal-row'>Make Final</th>
                                            <th className='p-4 wd-normal-row'>Make Demo</th>
                                            <th className="p-4 wd-normal-row"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {sheetData.map((item, index) => {
                                            const isDemo = item.final === 'd';
                                            return (
                                                <Draggable
                                                    key={index.toString()}
                                                    draggableId={index.toString()}
                                                    index={index}
                                                    isDragDisabled={isDemo}
                                                >
                                                {(provided) => (
                                                    <tr
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...(isDemo ? {} : provided.dragHandleProps)}
                                                        className="border border-gray-200 text-black text-sm"
                                                    >
                                                        {/*<td>{index}</td>*/}
                                                        <td className="p-2 custom-table-row-data">{item.name}</td>
                                                        <td className="p-2 custom-table-row-data">{
                                                            !Number.isInteger(Number(item["tabName"])) ?
                                                                item.evaluation : '--'
                                                        }</td>
                                                        <td className="p-2 custom-table-row-data">{item.tabName}</td>
                                                        <td className="p-2 custom-table-row-data">{item.passingScore}</td>
                                                        <td className="p-2 text-center">
                                                            <span className='custom-table-row-data'>{item.time}</span>
                                                        </td>
                                                        <td className="p-2 custom-table-row-data">{renderQuestionsColumn(item)}</td>
                                                        {/*<td className="p-2 custom-table-row-data">{renderMinAttemptsColumn(item)}</td>*/}
                                                        <td className='p-2 custom-table-row-data'>{item?.type}</td>
                                                        {/*<td className='p-2 custom-table-row-data'>{item?.difficulty}</td>*/}
                                                        <td className='p-2 custom-table-row-desc'>{item?.goalText}</td>
                                                        {/*<td className="p-2 custom-table-row-data">{item.final}</td>*/}
                                                        <td className="p-2 custom-table-row-data">
                                                            {!item.tabName.includes('Mini') &&
                                                                <Button
                                                                    color={item.final === 'y' ? 'danger' : 'success'}
                                                                    size="sm"
                                                                    onClick={() => handleMakeFinal(index)}
                                                                    disabled={item.final === 'y' || item.final === 'd'}
                                                                >
                                                                    {item.final === 'y' ?
                                                                        <i className="fa fa-times"/> :
                                                                        <i className="fa fa-check"/>
                                                                    }
                                                                </Button>
                                                            }
                                                        </td>
                                                        <td className="p-2 custom-table-row-data">
                                                            {!item.tabName.includes('Mini') &&
                                                                <Button
                                                                    color={item.final === 'd' ? 'danger' : 'success'}
                                                                    size="sm"
                                                                    onClick={() => handleMakeDemo(index)}
                                                                    disabled={item.final === 'd' || item.final === 'y'}
                                                                >
                                                                    {item.final === 'd' ?
                                                                        <i className="fa fa-times"/> :
                                                                        <i className="fa fa-check"/>
                                                                    }
                                                                </Button>
                                                            }
                                                        </td>
                                                        <td className="p-2 d-flex space-x-2 justify-content-start align-items-center mt-4 mr-2">
                                                            <>
                                                                <Link
                                                                    to={props.signedInUser.role === "admin" ? `/admin/levels/${eventId}/${item['tabName']}/edit` : `/admin/levels/${eventId}/${item['tabName']}/edit?superAdmin=${encodeURIComponent('gvb1hjj23n')}`}>
                                                                    <Button
                                                                        color="default"
                                                                        className="mx-2"
                                                                        size="sm"
                                                                        // onClick={() => history.push()}
                                                                        // /admin/levels/geniteams_asad/1/edit
                                                                    >
                                                                        <i className="fas fa-pencil-alt"/>
                                                                    </Button>
                                                                </Link>
                                                                {!item.tabName.includes('Mini') &&
                                                                    <Button
                                                                    color="primary"
                                                                    size="sm"
                                                                    onClick={() => history.push(props.signedInUser.role === "admin" ? `/admin/levelDetails/${eventId}/${item['tabName']}` : `/admin/levelDetails/${eventId}/${item['tabName']}?superAdmin=${encodeURIComponent('gvb1hjj23n')}`)}
                                                                >
                                                                    <i className="far fa-eye"/>
                                                                </Button>
                                                                }
                                                            </>
                                                        </td>
                                                    </tr>
                                                )}
                                            </Draggable>
                                            )
                                        })}
                                        {provided.placeholder}
                                        </tbody>
                                    </table>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Col>
                </Row>
                <Row className="mb-4">
                    {/*Skills*/}
                    <Col lg={8}>
                        <h2 className="mb-3 mt-3">Skills</h2>
                        <Card className="shadow mb-4 mb-lg-0">
                            <DataTable
                                columns={[
                                    {
                                        name: 'Name', minWidth: '20%', maxWidth: '30%',
                                        wrap: true, center: true,
                                        selector: row => row['name'],
                                    },
                                    {
                                        name: 'Text', wrap: true,
                                        selector: row => row['text'],
                                    },
                                ]}
                                data={lAbilities}
                                progressPending={loadingLevelData}
                                responsive
                                highlightOnHover
                                persistTableHead
                            />
                        </Card>
                    </Col>
                    {/*Characters*/}
                    <Col lg={4}>
                        <h2 className="mb-3 mt-3">Characters</h2>
                        <Card className="shadow">
                            <DataTable
                                columns={[
                                    {
                                        name: 'Character',
                                        wrap: true, center: true, minWidth: '20%', maxWidth: '30%',
                                        selector: row => row.name
                                    },
                                    {
                                        name: 'Name', minWidth: '50%',
                                        selector: row => row.value,
                                        cell: row => (
                                            <div className="w-100">
                                                {
                                                    editing === row.value ?
                                                        <Form
                                                            className="d-flex justify-content-around align-items-center"
                                                            onSubmit={async e => {
                                                                setLoading(row.value);

                                                                e.preventDefault();

                                                                let _index = -1;
                                                                const _data = miscellaneousData.map((_row, i) => {
                                                                    console.log(_row);
                                                                    if (_row.value === row.value) {
                                                                        _row.value = e.target[0].value;
                                                                        _index = i;
                                                                    }
                                                                    return _row;
                                                                });

                                                                if (_index >= 0) {
                                                                    const singleObject = {};

                                                                    for (const obj of miscellaneousData) {
                                                                        singleObject[obj.name] = obj.value;
                                                                    }
                                                                    // await _data[_index].save();
                                                                    const docRef = doc(getDb(), "miscellaneous", eventId);
                                                                    await updateDoc(docRef, {
                                                                        data: {
                                                                            ...singleObject
                                                                        }
                                                                    });
                                                                }

                                                                setMiscellaneousData(_data);

                                                                setLoading(null);
                                                                setEditing(null);
                                                            }}>
                                                            <Input bsSize="sm" className="form-control-alternative"
                                                                   type="text" name={row.value}
                                                                   defaultValue={row.value} required
                                                                   style={{maxWidth: '75%'}}/>
                                                            <Button
                                                                disabled={loading === row.value}
                                                                className="px-2 ml-2 mr-0"
                                                                color="success"
                                                                size="sm"
                                                                type="submit"
                                                            >
                                                                {
                                                                    loading === row.value ?
                                                                        <Spinner size="sm" color="light"/> :
                                                                        <i className="fas fa-check"/>
                                                                }
                                                            </Button>
                                                        </Form> :
                                                        <span>{row.value}</span>
                                                }
                                            </div>
                                        )
                                    },
                                    {
                                        name: '',
                                        minWidth: '10%',
                                        maxWidth: '15%',
                                        selector: row => null,
                                        cell: row => (
                                            <div>
                                                <Button
                                                    color={editing === row.value ? "danger" : "default"}
                                                    size="sm"
                                                    onClick={() => editing === row.value ? setEditing(null) : setEditing(row.value)}
                                                >
                                                    {
                                                        editing === row.value ?
                                                            <i className="fas fa-times"/> :
                                                            <i className="fas fa-pencil-alt"/>
                                                    }
                                                </Button>
                                            </div>
                                        )
                                    }
                                ]}
                                data={miscellaneousData}
                                progressPending={loadingLevelData}
                                highlightOnHover
                                responsive
                                persistTableHead
                            />
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
